import * as React from "react";
const SvgLoveItBreak = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	overflow: "visible",
	viewBox: "0 0 24 24",
	id: "love-it-break_icon",
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M23.32 5.2a6.58 6.58 0 0 0-10.45-1.71c-.21.19-.28.23-.31.32l-2.7 7.35a.24.24 0 0 0 0 .23.25.25 0 0 0 .2.1h4.79a.75.75 0 0 1 .72.96l-2.43 8.65a.27.27 0 0 0 .11.29.26.26 0 0 0 .31 0l8.21-8.46a6.39 6.39 0 0 0 1.55-7.73" }), /* @__PURE__ */ React.createElement("path", { d: "M13.8 13.31a.3.3 0 0 0 0-.22.28.28 0 0 0-.2-.1H8.66A.75.75 0 0 1 8 12l3-8.4a.25.25 0 0 0 0-.27 6.49 6.49 0 0 0-5.51-1.62A6.47 6.47 0 0 0 .7 5.2a6.39 6.39 0 0 0 1.19 7.45s7.36 7.94 9 9.65a.26.26 0 0 0 .24.07.26.26 0 0 0 .18-.17z" }));
export { SvgLoveItBreak as ReactComponent };
